import React, { useContext, useEffect, useState } from "react";
import {
  Avatar,
  Container,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TextField,
  Typography,
  IconButton,
  Button,
} from "@mui/material";
import {
  Search as SearchIcon,
  ArrowBack as ArrowBackIcon,
  ArrowForward as ArrowForwardIcon,
} from "@mui/icons-material";
import axios from "axios";
import GppGoodIcon from "@mui/icons-material/GppGood";
import { ContextData } from "../../../context/Context";
import baseUrl from "../../../BaseURL";
import AddMemberDialog from "../Contents/Registered/AddMemberDialog";
import ViewPopUserEdit from "../Contents/Registered/ViewPopUserEdit";
import IconDelete from "../Contents/FontIcons/IconDelete";
import IconView from "../Contents/FontIcons/IconView";
import ViewDialog from "../Contents/Applicants/ViewDialog";
import UndergraduateDialog from "../Contents/Applicants/UndergraduateDialog";
import PostgraduateDialog from "../Contents/Applicants/PostgraduateDialog";
import PeopleIcon from '@mui/icons-material/People';
import { Deleterequest, Getrequest } from "../../../context/AxiosRequest";
import { toast } from "react-toastify";
import GetAdminCredentials from "../../../context/GetAdminCredentials";
/* import EditStudentPop from './PopDialogue/Student/EditStudentPop';
 */

const LoanSupport = () => {

  
  const [searchText, setSearchText] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [StudentData, setApplicantData] = useState([]);
  const [CountData, setCountData] = useState(0);
  const [DataValue, setDataValue] = useState("not");
  const rowsPerPage = 6;
  const { setLoader,GlobalLoader,setGlobalLoader,accesstoken,UserTokens} = useContext(ContextData);
  const [applicantsList,setapplicantsList] = useState(null)
 
    const [UserType,setUserType] = React.useState("")
  
   const  user_roles = [
            "Administrator",
            "Manage",
            "Selector",
            "Validator",
            "Verifier",
            "Bank reviewer",
            "account-helper",
             "Manage Loan",
            "Manage Scholarship"
             ]
  
  
       

  useEffect(() => {
    async function FetchData() {
      //  setLoader(true)

      try {
        const response = await axios.get(`${baseUrl}/auth/get_all_applicant`, {
          withCredentials: true,
          headers: {
            Accept: "application/json",
            authorization: `Bearer ${
              accesstoken !== null && accesstoken
            }`,
          },
        });

        setCountData(Object.keys(response.data));
        setApplicantData(response.data);
       
      } catch (err) {
        if (err) console.log(err.message);
        // setLoader(false)
      }


      const aLLapplicantsList = await Getrequest(`/auth/count_all_applicants`,accesstoken)


        setapplicantsList(aLLapplicantsList)







    }
    FetchData();


          (async ()=>{ 
    
                    GetAdminCredentials(UserTokens,accesstoken).then(res =>{
                     setUserType(res)
                    })
                   
            })()


  }, [GlobalLoader,DataValue]);



  const handleSearchChange = (e) => {
    setSearchText(e.target.value);
  };



  const List = Object.keys(StudentData !== null && StudentData).map(
    (data) => StudentData[data]
  );



  const filteredUsers = List.filter((user) => {
    const lowerCaseSearchText = searchText.toLowerCase().trim();
    return user.email.toLowerCase().includes(lowerCaseSearchText);
    // Add more fields for search if needed (e.g., state, phone number)
  });



  const totalPages = Math.ceil(filteredUsers.length / rowsPerPage);
  const indexOfLastUser = currentPage * rowsPerPage;
  const indexOfFirstUser = indexOfLastUser - rowsPerPage;
  const usersToShow = filteredUsers.slice(indexOfFirstUser, indexOfLastUser);

  const handleNextPage = () => {
    setCurrentPage((prevPage) => prevPage + 1);
  };

  const handlePrevPage = () => {
    setCurrentPage((prevPage) => prevPage - 1);
  };

  const HanldeRemove = async (sttokens) => {

        const response = await Deleterequest(`/auth/remove_applicant/${sttokens}`,accesstoken)
           if(response){
             toast.success(response)
             setGlobalLoader(!GlobalLoader)
           }
  };

    const handleChange = (event) => {
    setDataValue(event.target.value);
  };

  return (
    <div className="con-dev">
      <Container>
        <div className="flex justify-between items-center">
          <div className=" flex gap-4 items-center">
            <Typography
              variant="h4"
              gutterBottom
              className="flex justify-between items-center"
            >
              <p className="font-extrabold mt-3">All Applicants</p>
            </Typography>
            <p className="text-xl font-bold"> <PeopleIcon /> {applicantsList !== null && applicantsList[0]?.total.toLocaleString()}</p>
          </div> 
           <div className="flex justify-center items-center mb-4 mt-4 gap-4">
          <p className="whitespace-nowrap">Select Application Type:</p>
            <select
            onChange={handleChange}
            value={DataValue}
            className="w-full p-2 rounded-md bg-[#030323e6] text-white font-bold"
            >
       {/*  <option value="scholarship">Scholarship Applications</option> */}
        <option value="not">Document</option>
        <option value="loan">Loan Application</option>
        <option value="loan">Acknowledgment</option>
       
      </select>
        </div>
        </div>

        <TextField
          label="Search by email, by matric number, by name or by institutte"
          variant="outlined"
          value={searchText}
          onChange={handleSearchChange}
          InputProps={{
            endAdornment: (
              <IconButton>
                <SearchIcon />
              </IconButton>
            ),
          }}
          fullWidth
          margin="normal"
        />
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow sx={{ background: "rgb(0, 24, 69)" }}>
                <TableCell
                  align="center"
                  sx={{ color: "white", fontWeight: "800" }}
                >
                  No.
                </TableCell>
                <TableCell
                  align="center"
                  sx={{ color: "white", fontWeight: "800" }}
                >
                  Full Name
                </TableCell>

                <TableCell
                  align="center"
                  sx={{ color: "white", fontWeight: "800" }}
                >
                  Qualification Type
                </TableCell>

                <TableCell
                  align="center"
                  sx={{ color: "white", fontWeight: "800" }}
                >
                  Matric No.
                </TableCell>
                <TableCell
                  align="center"
                  sx={{ color: "white", fontWeight: "800" }}
                >
                  Status
                </TableCell>
                <TableCell
                  align="center"
                  sx={{ color: "white", fontWeight: "800" }}
                >
                  View
                </TableCell>
                {
                  UserType[0]?.acct_typ === user_roles[0] &&
                <TableCell
                  align="center"
                  sx={{ color: "white", fontWeight: "800" }}
                >
                  Remove
                </TableCell>
                }
              </TableRow>
            </TableHead>
            <TableBody>
              {usersToShow.map((user, index) => (
                <TableRow key={index}>
                  <TableCell align="center" sx={{ whiteSpace: "nowrap" }}>
                    {index + 1}
                  </TableCell>
                  <TableCell align="center" sx={{ whiteSpace: "nowrap" }}>
                   {user.fname}  {user.lname}
                  </TableCell>

                  <TableCell align="center" sx={{ whiteSpace: "nowrap" }}>
                  {
                    user.applying_for_type === "undergraduate" ?
                    <span className="text-white bg-green-900 p-1 font-bold capitalize"> {user.applying_for_type}</span> 
                    : <span className="text-white bg-blue-900 p-1 font-bold capitalize"> {user.applying_for_type}</span>
                  }
                  </TableCell> 

                  <TableCell align="center" sx={{ whiteSpace: "nowrap" }}>
                    <span className=""> 
                      {
                    user.matric_num ?   user.matric_num: <span className="text-red-900">Not Provided</span>
                  }
                   </span>
                  
                  </TableCell>
                  <TableCell align="center" sx={{ whiteSpace: "nowrap" }}>
                    <p className="py-[.01rem] bg-gray-500 text-white">Pending</p>
                    {/* <p className="py-[.01rem] bg-blue-500 text-white">Applied</p>
                    <p className="py-[.01rem] bg-green-500 text-white">Awarded</p>
                    <p className="py-[.01rem] bg-red-500 text-white">Rejected</p> */}
                  </TableCell>
                  <TableCell align="center" sx={{ whiteSpace: "nowrap" }}>
                    
                  <ViewDialog usertoken={user.user_token} />
                  
                  </TableCell>
              {
                UserType[0]?.acct_typ === user_roles[0] &&
                  <TableCell align="center" sx={{ whiteSpace: "nowrap" }}>
                    <Button
                      className="Hover-"
                      onClick={() => HanldeRemove(user.user_token)}
                      elevation={10}
                      sx={{
                        whiteSpace: "nowrap",
                        backgroundColor: "rgb(199, 1, 1)",
                        margin: "9px 0px",
                      }}
                      size="small"
                      variant="contained"
                    >
                      <IconDelete
                        tooltipText="Remove Applicant"
                        tooltipColor="white"
                        tooltipIconSize="19px"
                      />
                    </Button>
                  </TableCell>
              }
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        {totalPages > 1 && (
          <div>
            {currentPage > 1 && (
              <Button
                className="Hover-"
                onClick={handlePrevPage}
                elevation={10}
                sx={{
                  whiteSpace: "nowrap",
                  fontSize: "14px",
                  backgroundColor: "rgb(0, 24, 69)",
                  color: "white",
                  margin: "9px 4px",
                }}
                size="large"
                variant="contained"
              >
                <ArrowBackIcon />
              </Button>
            )}
            <span>
              Page {currentPage} of {totalPages}
            </span>
            {currentPage < totalPages && (
              <Button
                className="Hover-"
                onClick={handleNextPage}
                elevation={10}
                sx={{
                  whiteSpace: "nowrap",
                  fontSize: "14px",
                  backgroundColor: "rgb(0, 24, 69)",
                  color: "white",
                  margin: "9px 4px",
                }}
                size="large"
                variant="contained"
              >
                <ArrowForwardIcon />
              </Button>
            )}
          </div>
        )}
      </Container>
    </div>
  );
};

export default LoanSupport;
